import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

type ReportState = {
  isSyncingToRedux: boolean;
  setIsSyncingToRedux: (isSyncing: boolean) => void;
};

export const useReportState = create<ReportState>()(
  devtools(
    set => ({
      isSyncingToRedux: false,
      setIsSyncingToRedux: (isSyncing: boolean) => {
        set(() => ({isSyncingToRedux: isSyncing}));
      },
    }),
    {name: 'ReportState'}
  )
);
